import React from "react";

const Context = React.createContext();

function InnerProviderSearch({children}) {

    const [state, setState] = React.useState("")

    return <Context.Provider value={{state, setState}}>{children}</Context.Provider>
}

export {Context, InnerProviderSearch}
